export interface IPack {
    id: string;
    color: string;
    brandImage: string;
    title: any;
    description: string;
    discount: number;
    value: number;
    unit: string;
    components: Component[];
    id_crm: string;
    is_available: boolean;
    is_contracted: boolean;
    contracts?: string[];
    type: number;
    name: string;
    recomend?: boolean;
    save?: string;
}

export class Pack implements IPack {
    private readonly HEALTH_REFERENCE: string = "health";
    public hasHealthPlan: boolean;

    constructor(
        public id: string,
        public color: string,
        public brandImage: string,
        public title: any,
        public description: string,
        public discount: number = 0,
        public value: number,
        public unit: string,
        public components: Component[],
        public id_crm: string,
        public is_available: boolean,
        public is_contracted: boolean,
        public contracts: string[],
        public type: number,
        public name: string,
        public recomend?: boolean,
        public save?: string,
    ) {
        this.hasHealthPlan = this.hasHealthPlanComponent();
    }

    private hasHealthPlanComponent(): boolean {
        return this.components.some(component => component.category.reference === this.HEALTH_REFERENCE && component.status === "1");
    }

    public isEasy(): boolean {
        return (this.type === 1);
    }

    public isSmart(): boolean {
        return (this.type === 2);
    }

    public isFull(): boolean {
        return (this.type === 3);
    }
}

export class PackFactory {
    static create(pack: IPack) {
        return new Pack(
            pack.id,
            pack.color,
            pack.brandImage,
            pack.title,
            pack.description,
            pack.discount ?  pack.discount : 0,
            pack.value,
            pack.unit,
            pack.components,
            pack.id_crm,
            pack.is_available,
            pack.is_contracted,
            pack.contracts,
            pack.type,
            pack.name,
            pack.recomend,
            pack.save,
        );
    }
}

export interface Category {
    id: string;
    icon: string;
    label: string;
    title: string;
    reference: string;

}

export class Component {
    constructor(
        public id: string,
        public title: string,
        public description: string,
        public description_mobile: string,
        public link: string,
        public value: string,
        public unit: string,
        public type: string,
        public status?: string,
        public category?: Category,
        public old_value?: string,
    ) {}
}

export class ComponentFactory {
    static create(component: Component) {
        return new Component(
            component.id,
            component.title,
            component.description,
            component.description_mobile,
            component.link,
            component.value,
            component.unit,
            component.type,
            component.status,
            component.category,
        );
    }
}
